import Vue from "vue";
import Vuex from "vuex";
import _package from "../../package.json";
import serialize from "../utils/serialize";

Vue.use(Vuex);

const serverURL = _package.server[process.env.NODE_ENV] || "http://192.168.0.200:5000";

export default {
  namespaced: true,
  state: {
    path: "/api/v2/telegram/head-teacher",
  },
  actions: {
    fetchTeachers({ dispatch, state, rootState }, options = {}) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/teachers?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },

    fetchStudents({ dispatch, state, rootState }, options = {}) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/students?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },

    fetchGroups({ dispatch, state, rootState }, options = {}) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/groups?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },

    fetchSchedule({ dispatch, state, rootState }, options = {}) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/schedule?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },

    fetchAttendance({ dispatch, state, rootState }, options = {}) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/attendance?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },

    fetchPerformance({ dispatch, state, rootState }, options = {}) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/performance?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },

    startGroupEducation({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/groups/start`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },

    getTeacherDetails({ dispatch, state, rootState }, teacherId) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/teachers/${teacherId}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },

    getStudentDetails({ dispatch, state, rootState }, studentId) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/students/${studentId}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },

    getGroupDetails({ dispatch, state, rootState }, groupId) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/groups/${groupId}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },

    updateGroup({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/groups/${data.groupId}`,
          method: "PUT",
          data,
        },
        { root: true }
      );
    },
  },
};
